(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isNewsletterMenu = this.querySelector('#footer-signup_form') !== null;

        // Desktop: all footer menus stay open.
        // Mobile: newsletter stays open by default; other menus stay collapsed.
        this.disclosure.open = isLargeScreen || isNewsletterMenu;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      /**
       * Newsletter panel contains an inset-shadow input. JS height animation
       * clips it into a visible horizontal bar — use native <details> instead.
       */
      checkTransitionsEnabled() {
        if (this.querySelector('#footer-signup_form') !== null) {
          this.transitionsEnabled = false;
          return;
        }
        this.transitionsEnabled = window.getComputedStyle(this.panel).transitionDuration !== '0s';
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-bfcm-deals"] && !Shopify.designMode) return;
  try {
    

class KcBfCarousel {
  constructor(root) {
    this.track = root.querySelector('.kc-bf-deals__track');
    this.prev = root.querySelector('[data-bf-prev]');
    this.next = root.querySelector('[data-bf-next]');
    this.update = () => { this.prev.disabled = this.track.scrollLeft < 2; this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2; };
    [this.prev,this.next].forEach((button,index) => button.addEventListener('click',() => this.track.scrollBy({left:(index ? 1 : -1) * (this.track.firstElementChild?.getBoundingClientRect().width + 18 || 300),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
    this.track.addEventListener('scroll',this.update,{passive:true});
    this.observer=new ResizeObserver(this.update); this.observer.observe(this.track); this.update();
  }
}
const kcBfInstances = new Map();
const kcBfInit = (scope=document) => scope.querySelectorAll('.kc-bf-deals').forEach(root => { if (!kcBfInstances.has(root)) kcBfInstances.set(root,new KcBfCarousel(root)); });
kcBfInit();
document.addEventListener('shopify:section:load',event => kcBfInit(event.target));
document.addEventListener('shopify:section:unload',event => { event.target.querySelectorAll('.kc-bf-deals').forEach(root => { kcBfInstances.get(root)?.observer.disconnect(); kcBfInstances.delete(root); }); });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-home-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kc-home-carousel')) {
  class KcHomeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.index = 0;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 3000);
      this.autoplay = this.dataset.autoplay === 'true';
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const controls = this.querySelector('.kc-home-carousel__controls');
      if (controls) controls.hidden = this.slides.length < 2;
      this.addEventListener('click', event => {
        const direction = event.target.closest('[data-direction]');
        const dot = event.target.closest('[data-slide-index]');
        if (direction) this.show(this.index + Number(direction.dataset.direction));
        if (dot) this.show(Number(dot.dataset.slideIndex));
        if (event.target.closest('[data-toggle]')) {
          this.paused = !this.paused;
          if (!this.paused) { this.hovered = false; this.focused = false; }
          this.updateControl();
        }
        this.schedule();
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.schedule();
      }, options);
      this.addEventListener('pointerdown', event => {
        this.touchStart = event.pointerType === 'touch' && !event.target.closest('a,button') ? { x: event.clientX, y: event.clientY } : null;
      }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          this.show(this.index + (dx < 0 ? 1 : -1));
          this.schedule();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateControl();
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (selected < 0) return;
        this.paused = true;
        this.show(selected);
        this.updateControl();
        this.schedule();
      }, options);
      if (this.slides[1]) this.slides[1].querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      this.updateControl();
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.abort) this.abort.abort();
      this.initialised = false;
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, position) => {
        if (position === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      this.dispatchEvent(new CustomEvent('kc:slidechange', { detail: { index: this.index } }));
    }
    updateControl() {
      if (!this.toggle) return;
      const label = this.paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.querySelector('[data-toggle-text]').textContent = label;
      this.querySelector('.kc-home-carousel__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, this.interval);
    }
  }
  customElements.define('kc-home-carousel', KcHomeCarousel);
}


  } catch(e) { console.error(e); }
})();
})();
